import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { getAPIUrl } from '../API'
import { ReportTypes } from '../apiConstants'

interface downloadCreditReportProps {
  creditReportId?: {
    data: {
      reportId: string
    }
  }
  setShowProgress: (value: boolean) => void
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
}

export const downloadCreditReport = (
  props: downloadCreditReportProps,
): void => {
  const { creditReportId, setShowProgress, setIsError, setErrorMessage } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId: creditReportId?.data?.reportId,
      reportType: ReportTypes.CreditEnquiryReport.reportTypeId,
    }),
  }
  setShowProgress(true)
  fetch(getAPIUrl() + '/CreditEnquiry/download-report', requestOptions)
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'consumerreport.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error: Error) => {
      setIsError(true)
      setShowProgress(false)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}
